<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>정보마당</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">정보마당</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">공지사항</p>
          <ul class="depth">
            <li><router-link to="/noticelist" title="공지사항">공지사항</router-link></li>
            <li><router-link to="/faqview" title="자주묻는질문">자주묻는질문</router-link></li>
            <li><router-link to="/qnalist" title="묻고 답하기">묻고 답하기</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">공지사항</h3>
        <article>
          <div class="table horizontal-table noticeView">
            <table>
              <caption>
                공지사항 상세 테이블
              </caption>
              <colgroup>
                <col style="width: 20%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <td colspan="2">
                    <div class="tableTitle">
                      <p class="tit">{{ boardObj.title }}</p>
                      <div class="right">
                        <span class="writer">{{ boardObj.updNm }}</span>
                        <span class="date">{{ boardObj.regDttm | ptDateFormat }}</span>
                        <span class="view">{{ boardObj.hits }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="tableCont">
                    <pre name="" id="">
                                            <div v-html="boardObj.cts" class="ckeditorCts"></div>
                                        </pre>
                  </td>
                </tr>
                <tr>
                  <th scope="row">첨부파일</th>
                  <td>
                    <article class="input-style button interval">
                      <div class="attach" v-for="(item, index) in attachList" :key="index">
                        <div class="file-name">
                          <span
                            v-if="attachList"
                            class="cursor"
                            @click="
                              downloadAttachFile(item.filePath, item.saveNm, item.viewNm, item.fileExt, item.repoId)
                            "
                          >
                            {{ item.viewNm }} ({{ item.fileSize | comma }})kb
                          </span>
                        </div>
                      </div>
                    </article>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="linkMove">
            <a @click="prevView" :class="{ disabled: prevIs }" class="prev"><p>이전글로 이동합니다.</p></a>
            <a @click="nextView" :class="{ disabled: nextIs }" class="next"><p>다음글로 이동합니다.</p></a>
          </div>
        </article>
        <article class="btnArea">
          <button type="button" class="btn border" @click="backToList">목록</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      atclId: '',
      prev: '',
      next: '',
      prevIs: false,
      nextIs: false,
      boardObj: {},
      attachList: [],
    };
  },

  mounted() {
    this.atclId = this.$route.query.atclId;
    this.initView(this.atclId);
  },

  methods: {
    async initView(atclId) {
      this.prev = '';
      this.next = '';
      const res = await axios('get', '/api/board/notice/view.json', {
        searchCondition: this.$route.query.searchCondition,
        searchKeyword: this.$route.query.searchKeyword,
        atclId: atclId,
        bbsCd: 'notice',
      });
      const data = res.data;
      this.boardObj = data.boardView;
      this.attachList = data.attachList;
      if (data.boardViewNext != null && data.boardViewPrev == null) {
        this.next = data.boardViewNext.atclId;
      } else if (data.boardViewPrev != null && data.boardViewNext == null) {
        this.prev = data.boardViewPrev.atclId;
      } else if (data.boardViewNext == null && data.boardViewPrev == null) {
        this.prev = '';
        this.next = '';
      } else {
        this.next = data.boardViewNext.atclId;
        this.prev = data.boardViewPrev.atclId;
      }
      if (this.prev == '' && this.next != '') {
        this.prevIs = true;
        this.nextIs = false;
      } else if (this.prev != '' && this.next == '') {
        this.prevIs = false;
        this.nextIs = true;
      } else if (this.prev == '' && this.next == '') {
        this.prevIs = true;
        this.nextIs = true;
      } else {
        this.prevIs = false;
        this.nextIs = false;
      }
    },

    prevView() {
      if (this.prevIs == true) {
        return;
      }
      this.initView(this.prev);
    },

    nextView() {
      if (this.nextIs == true) {
        return;
      }
      this.initView(this.next);
    },

    backToList() {
      this.$router.push({
        path: 'noticelist',
        query: {
          searchCondition: this.$route.query.searchCondition,
          searchKeyword: this.$route.query.searchKeyword,
          curPageNum: this.$route.query.curPageNum,
        },
      });
    },

    downloadAttachFile(filePath, saveNm, viewNm, fileExt, repoId) {
      location.href =
        '/api/board/notice/download.json?filePath=' +
        filePath +
        '&saveNm=' +
        saveNm +
        '&viewNm=' +
        viewNm +
        '&fileExt=' +
        fileExt +
        '&repoId=' +
        repoId;
    },
  },
};
</script>
